export default {
  fr: {
    title: "Suivre l'association",
    'social-media': (...arg: string[]) => `Suivez ${arg[0]} sur ${arg[1]}`,
  },
  en: {
    title: 'Follow the organization',
    'social-media': (...arg: string[]) => `Follow ${arg[0]} on ${arg[1]}`,
  },
  'pt-br': {
    title: 'Siga a organização',
    'social-media': (...arg: string[]) => `Siga ${arg[0]} no ${arg[1]}`,
  },
  es: {
    title: 'Siga la organización',
    'social-media': (...arg: string[]) => `Siga a ${arg[0]} en ${arg[1]}`,
  },
  de: {
    title: 'Folgen Sie der Organisation',
    'social-media': (...arg: string[]) => `Folgen Sie ${arg[0]} auf ${arg[1]}`,
  },
} as const
